export const yearLevels = [
  { value: 1, label: "1." },
  { value: 2, label: "2." },
  { value: 3, label: "3." },
  { value: 4, label: "4." },
  { value: 5, label: "5." },
];

export const JOB_TYPE_DESCRIPTIONS = [
  { value: "F", label: "Fast stilling" },
  { value: "S", label: "Internship" },
  { value: "T", label: "Trainee" },
  { value: "E", label: "Diplomoppgave" },
  { value: "D", label: "Deltid" },
  { value: "A", label: "Annet" },
];
